import { render, staticRenderFns } from "./RegieRequest.vue?vue&type=template&id=4d185075&scoped=true&"
import script from "./RegieRequest.vue?vue&type=script&lang=js&"
export * from "./RegieRequest.vue?vue&type=script&lang=js&"
import style0 from "./RegieRequest.vue?vue&type=style&index=0&id=4d185075&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d185075",
  null
  
)

export default component.exports